import React from "react";
import { Card, Typography, Box, Grid } from "@mui/material";
import { FaUsers, FaBullhorn, FaHandHoldingUsd, FaMoneyBillWave } from "react-icons/fa";
import COLORS from "../../../../../constants/colors";

const DashboardStats = ({ stats }) => {
  if (!stats) return null;

  const formatCurrency = (amount) => `UGX ${parseFloat(amount).toLocaleString("en-UG")}`;

  const statItems = [
    { icon: FaUsers, title: "Total Users", value: stats.total_users.toString(), color: "#1976d2" },
    { icon: FaBullhorn, title: "Total Campaigns", value: stats.total_campaigns.toString(), color: "#ff9800" },
    { icon: FaHandHoldingUsd, title: "Total Amount Raised", value: formatCurrency(stats.total_raised), color: COLORS.primary },
    { icon: FaMoneyBillWave, title: "Total Amount Withdrawn", value: formatCurrency(stats.total_withdrawn), color: "#d32f2f" },
  ];

  return (
    <Grid container spacing={3}>
      {statItems.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
              border: "1px solid rgba(0,0,0,0.05)",
              borderTop: `3px solid ${stat.color}`,
              p: 3,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              transition: "all 0.25s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
              },
            }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "12px",
                backgroundColor: `${stat.color}18`,
                color: stat.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <stat.icon size={20} />
            </Box>
            <Box>
              <Typography
                variant="h5"
                fontWeight="800"
                sx={{ color: "#1a1a2e", lineHeight: 1.2, letterSpacing: "-0.5px" }}
              >
                {stat.value}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#8a8f9d", fontWeight: 500, mt: 0.5, fontSize: "0.82rem" }}
              >
                {stat.title}
              </Typography>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardStats;
